import { Subscription, timer } from "rxjs";

import { OutletTiming } from "@app/shared/models/api-response/outlet-timing-response";

type CallbackFunction = () => void;

export class OutletCloseTimer {
    thersholdTime = 10 * 60; // in seconds
    isClosing = false;
    timeLeft: number;
    totalTime: string;
    timerSub$: Subscription;
    callbackFn: CallbackFunction;

    constructor(outlet_timing: OutletTiming, server_time: number, callbackFn: CallbackFunction) {
        this.callbackFn = callbackFn;
        this.isOutletClosing(outlet_timing, server_time);
    }

    isOutletClosing(outlet_timing: OutletTiming, server_time: number) {
        const closing_time = this._getCob(outlet_timing);
        const timeDiff = this._diff(closing_time, server_time);
        this.isClosing = !!(timeDiff && timeDiff <= this.thersholdTime);

        this.timeLeft = timeDiff;

        if (this.isClosing) {
            this._createCounter();
        }
    }

    private _getCob(outlet_timing: OutletTiming) {
        return new Date(outlet_timing.cob_time.replace(/-/g, '/')).getTime() / 1000; // in seconds
    }

    private _diff(closing_time: number, server_time: number) {
        const diff = closing_time - server_time;
        return diff > 0 ? diff : 0;
    }

    private _createCounter() {
        const secondsInMinute = 60;
        this.timerSub$ = timer(0, 1000).subscribe(() => {
            if (this.timeLeft >= 0) {
                const minutes = Math.floor(this.timeLeft / secondsInMinute);
                const seconds = this.timeLeft % secondsInMinute;
                const minText = (minutes === 0 || minutes === 1) ? 'min' : 'mins';
                this.totalTime = ` ${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds} ${minText}`;
                this.timeLeft--;
            } else {
                this.totalTime = "";
                this.callbackFn();
                this.timerSub$.unsubscribe();
            }
        });
    }
}
